import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';
import { HEADER_HEIGHT } from '~constant/layout';

export const SearchWrapper = styled.div`
  width: 100%;
  margin-left: 16px;
`;

export const FakeSearchBar = styled.div`
  width: 100%;
  height: 37px;
  position: relative;
  padding-left: 38px;
  background-color: ${({ theme }) => theme.colors.gray300};
  color: ${({ theme }) => theme.colors.gray600};
  border-radius: 999px;
  ${getFontStyle('midium150_B3')};
  line-height: 37px;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 8px;
  left: 14px;

  > * {
    vertical-align: top;
  }
`;

export const ButtonGnb = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${HEADER_HEIGHT}px;
  margin-left: 16px;
`;

export const ButtonLogin = styled(ButtonGnb)`
  flex: 0 0 24px;
`;

export const ButtonProfile = styled(ButtonGnb)`
  flex: 0 0 32px;
`;

export const ButtonToggle = styled(ButtonGnb)`
  flex: 0 0 48px;
  margin-left: 0;
`;
